import styled from 'styled-components';

export const StyledTable = styled.table`
  margin: 0 auto;
  p {
    margin: 0;
  }
`;

export const StyledTbody = styled.tbody`
  display: table-row-group;
  vertical-align: middle;
  border-color: inherit;
`;

export const StyledTd = styled.td`
  text-align: left;
`;

export const StyledDiv = styled.div`
  display: flex;
  align-items: center;
  margin-top: 5em;
  img {
    margin-right: 10px;
    height:160px;
  }
`;

export const StyledLang = styled.div`
  margin: 10px 0;
`;

export const StyledTitle = styled.p`
  font-weight: bold;
`;

export const StyledDesc = styled.p`
  font-size: 12px;
`;
